










import {Vue, Component, Lifecycle, Prop, p} from 'av-ts'

@Component
export default class LoadingSpinner extends Vue
{
    @Prop loading:any = p(
    {
        type: Boolean,
        required: true,
        default()
        {
            return false;
        }
    })

    // lifecycle hook
    @Lifecycle mounted()
    {
        
    }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoadingSpinner.vue